import * as DLBackExampleImage from "../assets/images/dl-back-example.svg";
import * as DLFrontExampleImage from "../assets/images/dl-front-example.svg";
import { DocType } from "./DocType";

export class DocExamples {
  private static docExamples: DocExample[] = [
    {
      docTypes: [
        DocType.LICENSE_BACK,
        DocType.LICENSE_FRONT_AND_BACK,
      ],
      info: {
        image: DLBackExampleImage,
        title: "BACK SIDE OF YOUR ID",
      },
    },
    {
      docTypes: [
        DocType.LICENSE_FRONT,
        DocType.LICENSE_FRONT_AND_BACK,
      ],
      info: {
        image: DLFrontExampleImage,
        title: "FRONT SIDE OF YOUR ID",
      },
    },
  ];

  public static getFirstByDocType = (docType: DocType): DocExample | undefined => {
    return DocExamples.docExamples.find( (d) => d.docTypes.indexOf(docType) >= 0);
  };

  public static getByDocType = (docType: DocType): DocExample[] => {
    return DocExamples.docExamples.filter( (d) => d.docTypes.indexOf(docType) >= 0);
  };
}

export interface DocExample {
  docTypes: DocType[];
  info: DocExampleInfo;
}

export interface DocExampleInfo {
  image: string;
  title: string;
}



// WEBPACK FOOTER //
// ./src/constants/DocExamples.ts